import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './Button.css';

function Button(props) {
  const { className, variant, ...rest } = props;
  const buttonStyles = classNames(styles.button, styles[variant], className);

  return <button {...rest} className={buttonStyles} />;
}

Button.defaultProps = {
  className: undefined,
  variant: 'default',
};

Button.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
};

export default Button;
